var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Включение ЛМСЗ в жизненную ситуацию")]},proxy:true}])},[_c('LMSPForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }